<template>

    <b-modal
        id="approve-menu-translations-modal"
        title="Zatwierdź tłumaczenia menu"
        :ok-only="!canBeApproved"
        :ok-title="canBeApproved ? 'Zatwierdź' : 'Zamknij'"
        :ok-variant="canBeApproved ? 'success' : 'secondary'"
        :cancel-title="canBeApproved ? 'Anuluj' : null"
        no-close-on-backdrop
        size="md"
        @ok="approve"
        @hidden="approveMenuTranslationsModalHandleHide">

        <div>

            <div class="mb-2">
                <strong>Menu</strong>
            </div>

            <div class="mb-5">
                <span class="badge badge-primary mr-1">{{ getRepoDisplayName(menu.repo) }}</span> <i class="fa fa-arrow-right"></i> <span class="badge badge-primary ml-1">{{ getRepoDisplayName(repo) }}</span>
            </div>

            <template v-if="canBeApproved">
                <b-alert variant="success" show class="mb-4">Tłumaczenia menu gotowe do zatwierdzenia</b-alert>
                <p>Podgląd zmian</p>
                <pre>{{ diffContent }}</pre>
            </template>

            <template v-if="!canBeApproved">
                <b-alert variant="danger" show>Nie można zatwierdzić tłumaczeń menu</b-alert>
                <p>{{ reason }}</p>
                <template v-if="diffKeys">
                    <p class="mb-0">Brakujące klucze:</p>
                    <ul>
                        <li v-for="key in diffKeys">{{ key }}</li>
                    </ul>
                </template>
            </template>


        </div>

    </b-modal>

</template>

<script>

    export default {

        name: 'GameLibraryApproveMenuTranslationsModal',

        data() {
            return {
                eventHub: window.eventHub,
                menu: {
                    repo: null
                },
                repo: null,
                canBeApproved: false,
                reason: null,
                diffKeys: [],
                diffContent: [],
            }
        },

        mounted() {

            this.eventHub.$on('game-library-show-approve-menu-translations-modal' , (menu) => {
                this.eventHub.$emit('processing-start');
                this.$bvModal.hide('approve-menu-modal');
                this.menu = menu;
                if (menu.repo === 'dev') {
                    this.repo = 'test';
                } else if (menu.repo === 'test') {
                    this.repo = 'prod';
                } else {
                    alert('Niepoprawne repozytorium menu: ' + menu.repo)
                }
                axios.get(route('game::game-library.check-if-menu-translations-can-be-approved', {repo: this.menu.repo}))
                    .then(response => {
                        this.canBeApproved = response.data.data.canBeApproved;
                        this.reason = response.data.data.reason;
                        this.diffKeys = response.data.data.diffKeys;
                        this.diffContent = response.data.data.diffContent;
                        this.eventHub.$emit('processing-finish');
                        this.$bvModal.show('approve-menu-translations-modal');
                    })
                    .catch(error => {
                        console.log(error);
                    });

            });

        },

        methods: {

            getRepoDisplayName(repo) {
                if (repo === 'dev') {
                    return 'Deweloperskie';
                } else if (repo === 'test') {
                    return 'Testowe';
                } else if (repo === 'prod') {
                    return 'Produkcyjne';
                }
                return 'Nieznane';
            },

            approveMenuTranslationsModalHandleHide() {

            },

            approve() {

                if (!this.canBeApproved) {
                    return;
                }

                this.eventHub.$emit('processing-start');

                axios.post(route('game::game-library.approve-menu-translations', {repo: this.menu.repo}))
                    .then(response => {
                        this.eventHub.$emit('game-library-menu-updated', response.data.data.menu);
                        this.$bvModal.hide('approve-game-translations-modal');
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.data.message, 'success');
                    })
                    .catch(error => {
                        console.log(error);
                    });


            }

        }

    }

</script>

<style>



</style>
